import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sod-calculator',
  component: () => import('../../routes/SodCalculator.svelte'),
  card: {
    id: 'sod-calculator',
    title: 'Sod Calculator',
    description:
      'Calculate sod pieces, pallets, and cost for any lawn size. Supports slab (16"×24") and roll (2ft×5ft) formats with adjustable waste factor and delivery fee.',
    icon: 'grass',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/sod-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Sod Calculator – Pieces, Pallets, and Cost for Any Lawn',
    description:
      'Free sod calculator. Estimate the number of slabs or rolls, pallets required (171 slabs / 50 rolls per pallet), and total cost with delivery for any lawn. Supports 16"×24" slabs and 2ft×5ft rolls with adjustable waste factor.',
  },
};

export default meta;
